import { jsxs as u, Fragment as d, jsx as _ } from "react/jsx-runtime";
import { createElement as a } from "react";
import c from "classnames";
import f from "../icon/Icon.js";
import '../../assets/List.css';const h = "_list_njmli_9", e = {
  list: h,
  "hide-bullets": "_hide-bullets_njmli_36",
  "custom-bullet": "_custom-bullet_njmli_40"
}, x = ({ children: m, as: i, className: r, bullets: s, ...l }) => {
  const o = !!s && s !== "hidden";
  return a(
    i,
    {
      // @ts-expect-error - data-testid is a unknown default property
      "data-testid": l["data-testid"] || i,
      className: c(
        e.list,
        {
          [e["hide-bullets"]]: s === "hidden",
          [e["custom-bullet"]]: o
        },
        r
      ),
      ...l
    },
    o ? m.map((n) => {
      const t = n.props;
      return a(
        "li",
        {
          key: n.key,
          ...t,
          className: c(e["item-with-icon"], t == null ? void 0 : t.className)
        },
        /* @__PURE__ */ u(d, { children: [
          /* @__PURE__ */ _(f, { name: s }),
          t.children
        ] })
      );
    }) : m
  );
};
export {
  x as default
};
